export const COLOR_MAP = {
  default: {
    text: "gray500",
    border: "gray300",
    icon: "gray700",
  },
  focus: {
    text: "gray500",
    border: "blue600",
    icon: "gray800",
  },
  selected: {
    text: "gray800",
    border: "gray300",
    icon: "gray800",
  },
  disabled: {
    text: "gray300",
    border: "gray300",
    icon: "gray300",
  },
} as const;
